import { Modal, ModalHeaderProps } from 'react-bootstrap';

export default function CustomModalHeader({
  className,
  ...props
}: ModalHeaderProps) {
  return <Modal.Header className={`border-0 ${className ?? ''}`} {...props} />;
}
